import moment from 'moment-tz';
import RRule from 'rrule';

import type {WriteTaskTemplateSerializedType} from 'sweet-types';

export interface TaskTemplateDraftType
  extends Omit<WriteTaskTemplateSerializedType, 'object_id' | 'content_type'> {
  object_id?: WriteTaskTemplateSerializedType['object_id'];
  content_type: WriteTaskTemplateSerializedType['content_type'];
}

export function createDraftTaskTemplate<
  U extends TaskTemplateDraftType = TaskTemplateDraftType
>(tz: string, initial: Partial<U> = {}): U {
  const due: string = moment
    .tz(undefined, tz)
    .set({
      hour: 17,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
    .toISOString();
  const rrule = new RRule({
    freq: RRule.DAILY,
    count: 1,
  }).toString();
  return {
    due,
    rrule,
    dtstart: due,
    force_dtstart: false,
    description: '',
    permission: 'view',
    ...initial,
  } as U;
}
